import { createTheme, ThemeProvider } from "@mui/material";
import { blue, pink } from "@mui/material/colors";
import { getAllEnumValues } from "enum-for";
import { BrowserRouter, Route, Routes } from "react-router-dom";
import "./App.css";
import { App as Apps, getAppSpec } from "./domain/App";
import { AppType } from "./domain/AppType";
import Home from "./pages/Home";
import PrivacyPolicy from "./pages/PrivacyPolicy";

function App() {
	const theme = createTheme({
		palette: {
			primary: blue,
			secondary: pink,
		},
	});

	return (
		<ThemeProvider theme={theme}>
			<BrowserRouter>
				<Routes>
					<Route path="/" element={<Home />}></Route>
					{getAllEnumValues(Apps)
						.map((it) => {
							return getAppSpec(it);
						})
						.map((it) => {
							const routePath = it.routePath;
							const path = `privacy-policy/${routePath}`;
							return (
								<Route
									path={path}
									element={<PrivacyPolicy appName={it.name} appType={it.type} />}
								/>
							);
						})}
					<Route
						path="privacy-policy/great-alchemy-2-no-ads"
						element={
							<PrivacyPolicy
								appName="Great Alchemy 2 (No Ads)"
								appType={AppType.PREMIUM}
							/>
						}
					></Route>
					<Route
						path="privacy-policy/angielski-slownictwo"
						element={
							<PrivacyPolicy
								appName="Angielski - Słownictwo"
								appType={AppType.FREE}
							/>
						}
					></Route>
					<Route
						path="privacy-policy/niemiecki-slownictwo"
						element={
							<PrivacyPolicy
								appName="Niemiecki - Słownictwo"
								appType={AppType.FREE}
							/>
						}
					></Route>
					<Route
						path="privacy-policy/green-garden"
						element={
							<PrivacyPolicy
								appName="Green Garden"
								appType={AppType.FREEMIUM}
							/>
						}
					></Route>
				</Routes>
			</BrowserRouter>
		</ThemeProvider>
	);
}

export default App;
